var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AgebotOverview"},[(_vm.angebote && _vm.angebote.length>0)?_c('H5',[_vm._v("\n  "+_vm._s(_vm.auftrag && _vm.auftrag.cutterId ? '1' : '0')+" / "+_vm._s(_vm.count('Angenommen'))+" / "+_vm._s(_vm.angebote.length)+"\n")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64c9f39e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/vue/components/partials/AngebotOverview.vue
// module id = null
// module chunks = 